var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "activity-stage"
  }, [_c('section', {
    ref: "truckStage",
    staticClass: "truck-stage"
  }, [_c('div', {
    ref: "truckContainer",
    staticClass: "truck-container"
  }, [_c('p', {
    ref: "provisionalLettersContainer",
    staticClass: "provisional-letters-container"
  }, _vm._l(_vm.currentStep.answer, function (char, index) {
    return _c('span', {
      key: char + index,
      staticClass: "letter-to-drop",
      attrs: {
        "track-by": "$index"
      }
    }, [_vm._v("\n          " + _vm._s(char) + "\n        ")]);
  }), 0), _vm.currentStep.answer ? _c('div', {
    ref: "truckLoad",
    staticClass: "truck-load"
  }, [_vm._l([_vm.currentStep], function (step) {
    return _c('blinking-cursor-text', {
      key: step.stepIndex,
      staticClass: "type-line",
      attrs: {
        "text-step": step.stepIndex,
        "text": step.answer
      }
    });
  }), _c('img', {
    attrs: {
      "src": _vm.truckLoadPath
    }
  })], 2) : _vm._e(), _c('img', {
    staticClass: "truck-body",
    attrs: {
      "src": _vm.truckBodyPath
    }
  })])]), _vm.currentRound.steps && _vm.currentRound.groupType ? _c('section', {
    ref: "wordToCompleteStage",
    class: {
      'word-to-complete-stage': true,
      isMobile: _vm.isMobile
    }
  }, _vm._l(_vm.currentRound.steps, function (step, index) {
    return _c('div', {
      key: index,
      class: 'word-container-' + index
    }, _vm._l(step.wordToComplete, function (charState, charIndex) {
      return _c('span', {
        key: charIndex + charState,
        class: _vm.getCharacterClass(charIndex, step.wordToComplete)
      }, [_vm._v("\n        " + _vm._s(charState.char) + "\n      ")]);
    }), 0);
  }), 0) : _vm._e(), _vm._t("keyboard")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }